import { useState, useEffect } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { useCreateFormMutation as useSendContactFormMutationLanding } from '@apis/mediacore/contact'
import axios from 'axios'
import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { Link } from 'gatsby'
import $ from 'jquery'

const ContactForm = ({
  global_data,
  image,
  spanText,
  items,
  opacityValue,
  backgroundColor,
  button,
  title,
  titleHexa,
  type,
  select,
}: RealEstateDataPageComponentData) => {
  const [submitted, setSubmitted] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const { captcha, tokko: tokkoKey } = global_data.pageConfig.keys
  // const GAEventsTracker = useGAEventTracker("PPC");

  const [token, setValueToken] = useState('')

  const [inputValue, setInputValue] = useState({
    nombre: '',
    email: '',
    telefono: '',
    fachada: '',
    comentario: '',
  })

  const handleChange = (event: any) => {
    setInputValue({ ...inputValue, [event.target.name]: event.target.value })
  }

  const [sendContactForm] = useSendContactFormMutationLanding()

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  const handleSubmit = (event: any) => {
    // let tags = [spanText || '']
    let tags = ['Landing']
    if (typeof window !== 'undefined') {
      var queryString = window.location.pathname.replaceAll('/', '')
      if (queryString) {
        tags.push(queryString)
      }
    }
    // if (type) {
    //   tags.push(type)
    // }

    for (const iterator of getUtm()) {
      tags.push(iterator)
    }

    formTokko(tags, inputValue)
    event.preventDefault()
    setSubmitted(true)
    // GAEventsTracker("Lead",1)
  }

  const formTokko = (
    tags: string[],
    fields: { nombre: string; email: string; fachada: string; telefono: string },
  ) => {
    // Campos del formulario.
    let body = ''
    var name = ''
    //Armo el texto del formulario.
    if (fields.nombre) {
      name += fields.nombre
    }

    if (fields.telefono) {
      body += 'Telefono: ' + fields.telefono + '\n'
    }

    if (select?.length! > 0) {
      for (let index = 0; index < select!.length; index++) {
        const element = select![index]
        let valorInicial = $('#select-' + index).val()
        body += element.title + ': ' + valorInicial + '\n '
      }
    }

    body += 'Email: ' + fields.email + '\n '
    if (fields.fachada) {
      body += 'Fachada: ' + fields.fachada + '\n '
    }

    //Agrego tags.
    var curTags = []
    tags.map((tag) => {
      curTags.push(tag)
    })

    //Armo todo el objeto a enviar
    var message = JSON.stringify({
      name,
      email: fields.email,
      tags,
      text: body,
      developments: parseInt(spanText || ''),
    })

    var commnet_var = ''

    if (select?.length! > 0) {
      for (let index = 0; index < select!.length; index++) {
        const element = select![index]
        let valorInicial = $('#select-' + index).val()
        commnet_var += element.title + ': ' + valorInicial + '\n '
      }
    }

    commnet_var += inputValue.comentario

    const data: any = {
      name: name,
      email: fields.email,
      phone: fields.telefono,
      message: commnet_var,
      tags: tags,
      property_id: '',
      url: window?.location?.href,
      token,
    }

    if (type) {
      data.development = type
    }

    if (spanText) {
      data.id = spanText
    }

    sendContactForm({
      data: data,
      type: 'landing',
      site: global_data.id,
    })

    // axios.post('https://tokkobroker.com/api/v1/webcontact/?key=' + tokkoKey + '', message, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
  }

  function onChange(value: any) {
    setValueToken(value)
  }

  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear()
    return currentYear
  }

  function addAlpha(color: string, opacity: number) {
    // coerce values so it is between 0 and 1.
    var _opacity = Math.round(Math.min(Math.max(opacity ?? 1, 0), 1) * 255)
    return color + _opacity.toString(16).toUpperCase()
  }

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  return (
    <div className="col-lg-4 text-center contact-column-col">
      <div className="row justify-content-end">
        <div
          id="response"
          className="col-lg-11"
        ></div>
        <div
          className="col-lg-11 p-4 p-lg-5"
          id="contact-column"
          style={{
            backgroundColor: addAlpha(
              backgroundColor || '#fff',
              Number(`0.${Number(opacityValue)}`),
            ),
            // opacity:
            //   opacityValue && opacityValue !== '0'
            //     ? Number(opacityValue) !== 100
            //       ? `0.${Number(opacityValue)}`
            //       : 1
            //     : 0.6,
          }}
        >
          <div className="form">
            {!submitted ? (
              <>
                <div className="header-wrapper">
                  <h5 style={{ color: titleHexa || '#1f1f1f1' }}>{title}</h5>
                  <img
                    src={image}
                    className="form-logo"
                    alt=""
                  />
                </div>
                <form
                  onSubmit={handleSubmit}
                  id="contacto"
                  className="mt-4"
                >
                  <input
                    style={{
                      background: addAlpha(backgroundColor || '#fff', 0.6),
                      border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                    }}
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="nombre"
                    placeholder="Nombre completo"
                  />
                  <input
                    style={{
                      background: addAlpha(backgroundColor || '#fff', 0.6),
                      border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                    }}
                    className="mb-lg-3 mb-3"
                    type="email"
                    onChange={handleChange}
                    name="email"
                    placeholder="Email *"
                    required
                  />
                  <input
                    style={{
                      background: addAlpha(backgroundColor || '#fff', 0.6),
                      border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                    }}
                    className="mb-lg-3 mb-3"
                    type="text"
                    onChange={handleChange}
                    name="telefono"
                    required
                    placeholder="Teléfono Celular *"
                  />
                  {select?.map((select, index) => (
                    <select
                      key={index}
                      required={select.required ? true : false}
                      className="mb-3"
                      name={'select-' + index}
                      id={'select-' + index}
                      style={{
                        background: addAlpha(backgroundColor || '#fff', 0.6),
                        border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                      }}
                    >
                      <option
                        selected
                        value=""
                        style={{
                          background: addAlpha(backgroundColor || '#fff', 0.6),
                          border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                        }}
                      >
                        Seleccioná una opción {select.required ? '*' : ''}
                      </option>
                      {select?.items?.map((option: string) => (
                        <option
                          style={{
                            background: addAlpha(backgroundColor || '#fff', 0.6),
                            border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                          }}
                          value={option}
                        >
                          {option}
                        </option>
                      ))}
                    </select>
                  ))}
                  <textarea
                    style={{
                      background: addAlpha(backgroundColor || '#fff', 0.6),
                      border: '1px solid' + addAlpha(titleHexa || '#fff', 0.4),
                    }}
                    onChange={handleChange}
                    className="mb-lg-3 mb-3"
                    name="comentario"
                    placeholder="Comentarios"
                    id=""
                    cols={20}
                    rows={5}
                  ></textarea>

                  {/* <!-- <button className="mt-3" type="submit">INVERTÍ AHORA</button> --> */}
                  <div className="d-flex flex-column align-items-center">
                    {captcha ? (
                      <ReCAPTCHA
                        sitekey={captcha}
                        onChange={(value) => {
                          setDisabled(false)
                          onChange(value)
                        }}
                      />
                    ) : (
                      ''
                    )}
                    <input
                      type="submit"
                      style={{
                        color: button?.valueColor,
                        backgroundColor: button?.backgroundColor,
                      }}
                      value={button?.value}
                      className="btn mt-4"
                      disabled={disabled}
                      id="submit-info"
                    />
                    {/* disabled={disabled}  */}
                  </div>
                </form>
              </>
            ) : (
              <>
                {/* {getScript()} */}
                <h5 className="mb-5 mx-auto">
                  ¡Gracias por participar!
                  <br /> Tu elección es muy importante
                  <br /> para nosotros.
                </h5>
                <Link
                  to="/"
                  onClick={() => setSubmitted(false)}
                  className="btn btn-link"
                  style={{
                    color: button?.valueColor,
                    backgroundColor: button?.backgroundColor,
                  }}
                >
                  VISITAR SITIO WEB
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="d-lg-none d-block bottom-logos mt-lg-3 mt-5">
        {items?.map((item) => (
          <div className="d-block justify-content-center white text-center flex-column">
            {
              <span className={'text-white ' + (item.title ? '' : 'd-none d-lg-block')}>
                {item.title}
              </span>
            }
            <img
              src={item.image}
              alt=""
            />
          </div>
        ))}
      </div>
      <footer
        className="mt-3 mt-lg-0 d-lg-none d-block "
        style={{ textAlign: 'center' }}
      >
        <p
          style={{ color: '#fff' }}
          className="copy"
        >
          Promoted by{' '}
          <a
            target="_blank"
            className="normal-color"
            href="https://mediahaus.com.ar"
          >
            {' '}
            MediaHaus
          </a>{' '}
          - Powered by{' '}
          <a
            target="_blank"
            className="white"
            href="https://mediacore.app/"
            style={{ color: '#fff' }}
          >
            {' '}
            MediaCore
          </a>
          <br />
          <span className="small-text">Todos los derechos reservados ® {getCurrentYear()}</span>
        </p>
      </footer>
    </div>
  )
}

export default ContactForm
